<template>
  <div class="container wrapper wrapper_page">
    <div class="row">
      <div class="col-lg-8">
        <div class="card__left">
          <OneOffer
            v-for="(lead, leadIdx) of leads"
            :key="lead.id"
            :lead="lead"
            :class="nonFirstLeadPagging(leadIdx)"
          />
          <PersonalAgent type="mobile"/>
        </div>
      </div>
      <div class="col-lg-4">
        <PersonalAgent type="desktop"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OneOffer from './OneOffer/OneOffer.vue'
import PersonalAgent from './PersonalAgent.vue'


export default {
  name: 'GeneralContainer',
  components: {
    OneOffer,
    PersonalAgent,
  },
  computed: {
    ...mapGetters(['leads']),
  },
  methods: {
    nonFirstLeadPagging(leadIdx) {
      return leadIdx === 0 ? '' : 'some-paddings'
    },
  },
}
</script>

<style scoped>
.some-paddings {
  padding-top: 108px;
}
</style>
